import React from 'react'
import { FormControlLabel, TableRow, TableCell } from '@material-ui/core'
import Switch from '../../common/Inputs/Switch'
import CheckBox from '../../common/Inputs/CheckBox/CheckBox'
import Typography from '../../common/Typography'
import { InlineContainer } from '../../common/Containers'

const RolePermissionRow = ({
  itemKey,
  itemName,
  permissions = {},
  allowedPermissions = {
    view: true,
    edit: true,
    create: true,
    delete: true,
  },
  viewOnly = false,
  onChange,
}) => {
  const handleChange = (type) => (ev) => {
    onChange(itemKey, type, ev.target.checked)
  }

  const isViewAllowed = allowedPermissions.view !== false
  const isViewLocked = Boolean(allowedPermissions.viewLocked)
  const isEditAllowed = allowedPermissions.edit !== false
  const isCreateAllowed = allowedPermissions.create !== false
  const isDeleteAllowed = allowedPermissions.delete !== false

  return (
    <TableRow key={itemKey} style={{ width: '50%' }}>
      <TableCell align="left" style={{ width: '50%', padding: '0 !important' }}>
        <InlineContainer style={{ marginLeft: '16px' }}>
          <Typography style={{ fontSize: '14px' }}>{itemName}</Typography>
        </InlineContainer>
      </TableCell>
      <TableCell align="left" style={{ width: '13%', padding: '0 !important' }}>
        <InlineContainer>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(permissions.view) && isViewAllowed}
                inputProps={{ 'aria-label': 'module' }}
                color="primary"
                disabled={!isViewAllowed || isViewLocked}
                onChange={handleChange('view')}
                name={`switch-view-${itemKey}`}
              />
            }
            style={{ fontSize: '12px' }}
            label="Can View"
          />
        </InlineContainer>
      </TableCell>
      {viewOnly ? (
        <>
          {/* View-only feature: render empty cells so the "Can View" toggle
              stays horizontally aligned with full-permission rows. */}
          <TableCell align="left" style={{ width: '8%', padding: '0 !important' }} />
          <TableCell align="left" style={{ width: '13%', padding: '0 !important' }} />
          <TableCell align="left" style={{ width: '13%', padding: '0 !important' }} />
        </>
      ) : (
        <>
          <TableCell align="left" style={{ width: '8%', padding: '0 !important' }}>
            <InlineContainer>
              <FormControlLabel
                control={
                  <CheckBox
                    onChange={handleChange('edit')}
                    checked={Boolean(permissions.edit)}
                    color={permissions.edit ? 'secondary' : '#EDEDED'}
                    disabled={!isEditAllowed}
                    style={
                      !permissions.view || !isEditAllowed ? { opacity: '0.3' } : {}
                    }
                    name={`checkbox-edit-${itemKey}`}
                  />
                }
                style={{ fontSize: '12px' }}
                label="Edit"
              />
            </InlineContainer>
          </TableCell>
          <TableCell align="left" style={{ width: '13%', padding: '0 !important' }}>
            <InlineContainer>
              <FormControlLabel
                control={
                  <CheckBox
                    onChange={handleChange('create')}
                    checked={Boolean(permissions.create)}
                    color={permissions.create ? 'secondary' : '#EDEDED'}
                    disabled={!isCreateAllowed}
                    style={
                      !permissions.view || !isCreateAllowed ? { opacity: '0.3' } : {}
                    }
                    name={`checkbox-create-${itemKey}`}
                  />
                }
                style={{ fontSize: '12px' }}
                label="Add/Create"
              />
            </InlineContainer>
          </TableCell>
          <TableCell align="left" style={{ width: '13%', padding: '0 !important' }}>
            <InlineContainer>
              <FormControlLabel
                control={
                  <CheckBox
                    onChange={handleChange('delete')}
                    checked={Boolean(permissions.delete)}
                    color={permissions.delete ? 'secondary' : '#EDEDED'}
                    disabled={!isDeleteAllowed}
                    style={
                      !permissions.view || !isDeleteAllowed ? { opacity: '0.3' } : {}
                    }
                    name={`checkbox-delete-${itemKey}`}
                  />
                }
                style={{ fontSize: '12px' }}
                label="Delete"
              />
            </InlineContainer>
          </TableCell>
        </>
      )}
    </TableRow>
  )
}

export default RolePermissionRow
